import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SearchboxService, WindowRef } from '@spartacus/core';
import { BOOLEAN_TO_ASYNCS } from '../../../../core/models/booleans-to-async.model';
import { Router } from '@angular/router';
import { DEVICE_SIZE } from '../../../../core/models/others.model';
import { isEmpty } from '../../../../core/services/simple-tools';

@Component({
  selector: 'search-box-by-modal',
  templateUrl: './search-box-by-modal.component.html',
  styleUrl: './search-box-by-modal.component.scss',
  standalone: false,
})
export class SearchBoxByModalComponent implements OnInit, OnDestroy {
  DEVICE_SIZE = DEVICE_SIZE;
  hasSearch$ = new BehaviorSubject(BOOLEAN_TO_ASYNCS.FALSE);
  currentFreeTextSearch$ = new BehaviorSubject('');
  showSearchBox$ = new BehaviorSubject(false);
  subscriptions = new Subscription();
  BOOLEAN_TO_ASYNCS = BOOLEAN_TO_ASYNCS;

  constructor(
    private searchboxService: SearchboxService,
    private winRef: WindowRef,
    private renderer: Renderer2,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // this.open();
    this.checkCurrentSearch();
    this.handleKeyboardEvent();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  checkCurrentSearch() {
    this.subscriptions.add(
      this.searchboxService.getResults().subscribe(data => {
        this.hasSearch$.next(isEmpty(data.freeTextSearch) ? BOOLEAN_TO_ASYNCS.FALSE : BOOLEAN_TO_ASYNCS.TRUE);
        this.currentFreeTextSearch$.next(data.freeTextSearch || '');
      }),
    );
  }

  open() {
    this.showSearchBox$.next(true);

    setTimeout(() => {
      this.renderer.selectRootElement('.searchbox input', true).focus();
      this.renderer.selectRootElement('.searchbox input', true).value = this.currentFreeTextSearch$.getValue() || '';
      this.winRef.isBrowser() && this.winRef.document.body.classList.add('overflow-hidden');
    }, 100);
  }

  closeBySearchButton() {
    this.close();
  }

  close() {
    this.showSearchBox$.next(false);
    this.winRef.isBrowser() && this.winRef.document.body.classList.remove('overflow-hidden');
  }

  closeByContainer(el: any) {
    const isContainer =
      el && el.target && el.target.classList && el.target.classList.contains('js-container-search-modal');
    const isResult = el.target.closest('.results') !== null;

    (isContainer || isResult) && this.close();
  }

  clearSearch() {
    this.searchboxService.clearResults();
    this.router.navigate(['']);
  }

  handleKeyboardEvent() {
    const _this = this;

    if (this.winRef.isBrowser()) {
      this.winRef.document.body.addEventListener('keyup', function (event) {
        try {
          const searchModalIsActive = _this.renderer.selectRootElement('.js-container-search-modal', true);
          const closeHotkeys = ['Enter', 'Esc', 'Escape'];

          searchModalIsActive && closeHotkeys.includes(event.key) && _this.close();
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {}
      });
    }
  }
}
